/* @flow */

import { type AxiosPromise } from 'axios';
import Swal from 'sweetalert2';
import getInputPorId from '../../utils/get-input-por-id';
import xhr from '../../utils/xhr';
import mensagemSucesso from '../nova-empresa-por-etapa/mensagem-sucesso';
import exibirErro from '../../utils/exibir-erro';
import getElementoPorId from '../../utils/get-elemento-por-id';
import proximaEtapa from '../nova-empresa-por-etapa/proximaEtapa';

import { type UrlLojas } from '../../empresa/types';

const cadastrarUrlsLojas = (empresasId: number, urlLojas: UrlLojas): AxiosPromise<*> => xhr.post(`/empresas/${empresasId}/urls-lojas`, urlLojas);

const getDadosFormularioUrlLojas = (): UrlLojas => ({
    android: getInputPorId('android-empresas-urls-lojas').value,
    ios: getInputPorId('ios-empresas-urls-lojas').value,
    download: getInputPorId('download-empresas-urls-lojas').value,
});

const preencherFormularioUrlsLojas = (urlLojas: UrlLojas) => {
    const form = getElementoPorId('formulario-urls-lojas');
    const inputDownloadUrlLoja = getInputPorId('download-empresas-urls-lojas');
    const iconeDesbloqueioUrlDownload = document.getElementById('desbloquear-input-download');
    getInputPorId('ios-empresas-urls-lojas').value = urlLojas.ios;
    getInputPorId('android-empresas-urls-lojas').value = urlLojas.android;
    inputDownloadUrlLoja.value = urlLojas.download;
    iconeDesbloqueioUrlDownload.hidden = false;

    if (urlLojas.download) {
        inputDownloadUrlLoja.disabled = true;
        iconeDesbloqueioUrlDownload.className = 'la la-unlock';
    }

    if (iconeDesbloqueioUrlDownload) {
        iconeDesbloqueioUrlDownload.onclick = () => {
            Swal.fire({
                type: 'warning',
                title: 'Deseja realmente alterar URL de Download?',
                text: 'É altamente recomendável a não alteração desta URL, pois se o cliente investiu em mídia baseado nesta URL, estas mesmas serão perdidas.',
                showCancelButton: true,
                confirmButtonText: 'Sim, alterar URL!',
                cancelButtonColor: 'red',
                cancelButtonText: 'Não, não alterar!',
            }).then((e) => {
                if (e.value) {
                    iconeDesbloqueioUrlDownload.className = 'la la-unlock-alt';
                    iconeDesbloqueioUrlDownload.hidden = true;
                    inputDownloadUrlLoja.disabled = false;
                }
            });
        };
    }

    form.onsubmit = async (e) => {
        e.preventDefault();
        Swal.fire({
            type: 'warning',
            title: 'Deseja realmente alterar URL de Download?',
            text: 'Esteja ciente de que esta alteração alterará o link de download dos apps.',
            showCancelButton: true,
            confirmButtonText: 'Sim, alterar URL!',
            cancelButtonColor: 'red',
            cancelButtonText: 'Não, não alterar!',
        }).then((resp) => {
            if (resp.value) {
                try {
                    cadastrarUrlsLojas(urlLojas.empresasId, getDadosFormularioUrlLojas());
                    mensagemSucesso('Urls cadastradas');
                    proximaEtapa('item-packages');
                } catch (err) {
                    exibirErro(err);
                }
            }
        });
    };
};

export {
    preencherFormularioUrlsLojas,
    getDadosFormularioUrlLojas,
    cadastrarUrlsLojas,
};
